import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import MenuBookLayout from './components/layouts/menubooklayout';
import Home from './pages/home';
import { Kioskpageversion } from './pages/kioskpageversion';
import MenuItems from './pages/menuitems';
import Stores from './pages/stores';
import PageVersions from './pages/pageversions';
import { AddOns } from './components/addons/addons'; // ToDo: Move component under pages directory
import { MenuOptions } from './components/menuOptions/menuoptions'; // ToDo: Move component under pages directory
import Attractor from './pages/attractor';
import PageVersionApprovalRequests from './pages/pageversionapprovals';
import ReviewApproval from './pages/reviewapproval';
import SimulatorPreview from './pages/simulatorpreview';
import Users from './pages/users';
import Roles from './pages/roles';
import BusinessUnits from './pages/businessunits';
import OutOfStock from './pages/outofstock';
import { GlobalLoadingProvider } from './components/common/globalloadingcontext';
import DeviceManagementPage from './pages/devicemanagement';
import DeviceDetailsPage from './pages/devicedetailspage';
import ItemBlockPage from './pages/itemblock';
import Languages from './pages/languages';
import Currencies from './pages/currencies';
import { LoginCallback } from '@okta/okta-react';
import NutrigenUpcLinks from './pages/nutrigenupclinks';
import ForcedUpsell from './pages/upsell/forcedupsell';
import TriggeredUpsell from './pages/upsell/triggeredupsell';
import AnalyticsSessionsPage from './pages/analyticsSessions';
import AnalyticsInsightsPage from './pages/analyticsInsights';
import AnalyticsHeatmapPage from './pages/analyticsHeatmap';
import SelectBusinessUnit from './pages/selectbusinessunit';
import BUGuard from './components/common/buguard';

const App: React.FC = () => {

  return (
    <ConfigProvider
      theme={{
        token: {
          green: '#549136',
        },
        components: {
          Tree: {
            colorBgContainer: 'transparent',
          },
          Menu: {
            darkItemBg: 'var(--color-primary)',
            darkItemSelectedBg: 'transparent',
            darkSubMenuItemBg: 'var(--color-primary)',
            darkItemHoverBg: '#776ef0',
            darkPopupBg: 'var(--color-primary)',
          },
        },
      }}
    >
      <GlobalLoadingProvider>
        <div className='-fluid'>
          <Routes>
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/selectbusinessunit" element={<SelectBusinessUnit />} />
            <Route path="/attractor" element={<BUGuard><MenuBookLayout><Attractor /></MenuBookLayout></BUGuard>} />
            <Route path="/" element={<BUGuard><MenuBookLayout><Home /></MenuBookLayout></BUGuard>} />
            <Route path="/:id" element={<BUGuard><Home /></BUGuard>} />
            <Route path="kioskpageversion/:id?" element={
              <BUGuard><MenuBookLayout><Kioskpageversion hasUnsavedChanges={false} handleUnsavedChanges={() => { }} /></MenuBookLayout></BUGuard>
            } />
            <Route path="pageversions" element={<BUGuard><MenuBookLayout><PageVersions /></MenuBookLayout></BUGuard>} />
            <Route path="menuoptiongroup" element={<BUGuard><MenuBookLayout><MenuOptions /></MenuBookLayout></BUGuard>} />
            <Route path="addons" element={<BUGuard><MenuBookLayout><AddOns /></MenuBookLayout></BUGuard>} />
            <Route path="/menuitems" element={<BUGuard><MenuBookLayout><MenuItems /></MenuBookLayout></BUGuard>} />
            <Route path="/stores" element={<BUGuard><MenuBookLayout><Stores /></MenuBookLayout></BUGuard>} />
            <Route path="/approvals" element={<BUGuard><MenuBookLayout><PageVersionApprovalRequests /></MenuBookLayout></BUGuard>} />
            <Route path="/approvals/review/:id" element={<BUGuard><MenuBookLayout><ReviewApproval /></MenuBookLayout></BUGuard>} />
            <Route path="/simulator/:pageversionguid" element={<BUGuard><MenuBookLayout><SimulatorPreview /></MenuBookLayout></BUGuard>} />
            <Route path="/users" element={<BUGuard><MenuBookLayout><Users /></MenuBookLayout></BUGuard>} />
            <Route path="/roles" element={<BUGuard><MenuBookLayout><Roles /></MenuBookLayout></BUGuard>} />
            <Route path="/businessunits" element={<BUGuard><MenuBookLayout><BusinessUnits /></MenuBookLayout></BUGuard>} />
            <Route path="/devices" element={<BUGuard><MenuBookLayout><DeviceManagementPage /></MenuBookLayout></BUGuard>} />
            <Route path="/devices/:deviceId" element={<BUGuard><MenuBookLayout><DeviceDetailsPage /></MenuBookLayout></BUGuard>} />
            <Route path="/outofstock" element={<BUGuard><MenuBookLayout><OutOfStock /></MenuBookLayout></BUGuard>} />
            <Route path="/itemblock" element={<BUGuard><MenuBookLayout><ItemBlockPage /></MenuBookLayout></BUGuard>} />
            <Route path="/languages" element={<BUGuard><MenuBookLayout><Languages /></MenuBookLayout></BUGuard>} />
            <Route path="/currencies" element={<BUGuard><MenuBookLayout><Currencies /></MenuBookLayout></BUGuard>} />
            <Route path="/nutrigenupclinks" element={<BUGuard><MenuBookLayout><NutrigenUpcLinks /></MenuBookLayout></BUGuard>} />
            <Route path="/upsell/forced" element={<BUGuard><MenuBookLayout><ForcedUpsell /></MenuBookLayout></BUGuard>} />
            <Route path="/upsell/triggered" element={<BUGuard><MenuBookLayout><TriggeredUpsell /></MenuBookLayout></BUGuard>} />
            <Route path="/analytics/sessions" element={<BUGuard><MenuBookLayout><AnalyticsSessionsPage /></MenuBookLayout></BUGuard>} />
            <Route path="/analytics/insights" element={<BUGuard><MenuBookLayout><AnalyticsInsightsPage /></MenuBookLayout></BUGuard>} />
            <Route path="/analytics/heatmap" element={<BUGuard><MenuBookLayout><AnalyticsHeatmapPage /></MenuBookLayout></BUGuard>} />
          </Routes>
        </div>
      </GlobalLoadingProvider>
    </ConfigProvider>
  );
};

export default App;
